import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Row, Col, Form } from "react-bootstrap";
import { BsPencil, BsCheck, BsX } from "react-icons/bs";
const BankView = ({ bankData, setBankDetails }) => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [editedBankData, setEditedBankData] = useState(bankData);
    const [setupIdError, setSetupIdError] = useState('');
    const [isSetupIdEditing, setIsSetupIdEditing] = useState(false);
    const [editField, setEditField] = useState(null);
    const [countries, setCountries] = useState([]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'setup_id') {
            setIsSetupIdEditing(true);
        }
        setEditedBankData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    const fetchCountries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/countries`, {
                headers: { Authorization: `Bearer ${token}`,
                'Tenant-Origin': origin,

             },
                skipLoader: true,
            });

            let countryList = response.data.Data;

            console.log("API Response Data:", countryList);

            // Ensure only one USD (United States) is included
            countryList = countryList.filter(
                (c) =>
                    c.currency !== "USD" ||
                    (c.name && c.name.toLowerCase().includes("united states"))
            );
    
            // Sort AED first, then USD (United States), then others
            countryList.sort((a, b) => {
                const priority = { AED: 0, USD: 1 }; // Set priority
                const aPriority = priority[a.currency] ?? 2;
                const bPriority = priority[b.currency] ?? 2;
                return aPriority - bPriority;
            });
    
            console.log("Filtered and sorted country list:", countryList.map(c => `${c.country_name || 'Unknown'} - ${c.currency}`));
    
            setCountries(countryList);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };
    useEffect(() => {
        fetchCountries();

    }, []);

    const handleSave = async () => {
        if (isSetupIdEditing) {
            setSetupIdError('');
        }
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            await axios.put(`${backendUrl}/api/bank-accounts/${bankData.id}`, editedBankData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });
            setBankDetails((prevDetails) => ({
                ...prevDetails,
                ...editedBankData, // Update only the changed fields
            }));
            setEditField(null);
        } catch (error) {
            if (error.response?.data?.errors?.setup_id) {
                setSetupIdError(error.response.data.errors.setup_id[0]);
            } else {
                console.error('Error saving bank details:', error);
            }
        }
    };
    const getCountryName = (id) => {
        if (!id || countries.length === 0) return "--";
        const country = countries.find((coun) => Number(coun.id) === Number(id));
        return country ? country.currency : "--";
    };
    // Fields configuration
    const fields = [
        { name: 'name', label: 'Name', type: 'text' },
        { name: 'branch_name', label: 'Branch Name', type: 'text' },
        { name: 'account_holder_name', label: 'Account Holder Name', type: 'text' },
        { name: 'account_number', label: 'Account Number', type: 'text' },


        { name: 'iban', label: 'IBAN', type: 'text' },
        { name: 'swift_code', label: 'SWIFT/BIC Code', type: 'text' },

        { name: 'bank_address', label: 'Bank Address', type: 'text' },
        { name: 'opening_balance', label: 'Opening Balance', type: 'text' },

        { name: 'currency_id', label: 'Currency', type: 'select', options: countries.map((coun) => ({ value: coun.id, label: coun.currency })), format: getCountryName },
        { name: 'exchange_rate', label: 'Exchange Rate', type: 'text' },



    ];

    const visibleFields = fields.filter((field) => {
        if (bankData.type === "cash account") {
            return ["name", "opening_balance", "currency_id", "exchange_rate"].includes(field.name);
        }
        return true; // Show all fields for bank accounts
    });



    // Group fields into rows (3 fields per row)
    const rows = [];
    for (let i = 0; i < visibleFields.length; i += 3) {
        rows.push(visibleFields.slice(i, i + 3));
    }




    return (
        <div className="p-3 font-size-13">
            <Row>
                {visibleFields.map((field, index) => (
                    <Col md={6} key={index} className="mb-2 d-flex align-items-center ps-5">
                        <strong className="view-label">
                            {field.label}:
                        </strong>
                        <div className="editable-container d-flex align-items-center">
                            {editField === field.name ? (
                                <div className="d-flex align-items-center">
                                    {field.type === "select" ? (
                                        <Form.Select
                                            name={field.name}
                                            value={editedBankData[field.name] || ""}
                                            onChange={handleChange}
                                            autoFocus
                                            className="form-control form-feild"
                                        >
                                            <option value="">Select</option>
                                            {field.options.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    ) : (
                                        <Form.Control
                                            type="text"
                                            name={field.name}
                                            value={editedBankData[field.name] || ""}
                                            onChange={handleChange}
                                            autoFocus
                                            className="form-control form-feild"
                                        />
                                    )}
                                    <BsCheck className="text-success mx-2" onClick={handleSave} style={{ cursor: "pointer" }} />
                                    <BsX className="text-danger" onClick={() => setEditField(null)} style={{ cursor: "pointer" }} />
                                </div>
                            ) : (
                                <div className="hover1"
                                    onClick={() => !field.readOnly && setEditField(field.name)}>
                                    <span className="hover-field1">
                                        {field.name === "currency_id"
                                            ? getCountryName(editedBankData[field.name]) // Get currency name
                                            : editedBankData[field.name] || "-"}                                    
                                            </span>
                                    {!field.readOnly && <BsPencil className="text-primary pencil-icon1" />}
                                </div>

                            )}
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default BankView;